import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_NHSV_ACCOUNT_DETAIL_API_ID =
  'DASHBOARD/FETCH_NHSV_ACCOUNT_DETAIL_API';

const apiCall = createApiCall(
  FETCH_NHSV_ACCOUNT_DETAIL_API_ID,
  (params: { account_number: string }) => ({
    endpoint: generateEndpoint({
      host: '/api/admin/nhsv/account-detail',
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
